import script from "./PerfilView.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilView.vue?vue&type=script&setup=true&lang=js"

import "./PerfilView.vue?vue&type=style&index=0&id=3fb77abd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb77abd"]])

export default __exports__